import React from "react";
import { connect } from "react-redux";
import type { Dispatch } from "redux";

import type { ActionTypes, ReduxState } from "../reducers/reducers";

export type GanttChartStandaloneCallbacksProps = {
    onInsightTypesChange: () => Promise<void>;
    onShowPastProductionsChange: () => Promise<void>;
};

type OwnProps = GanttChartStandaloneCallbacksProps;
type Props = OwnProps & ReduxProps;

class GanttChartStandaloneCallbacks extends React.Component<Props> {
    componentDidUpdate(prev_props: Props) {
        if (prev_props.insight_types !== this.props.insight_types && this.props.onInsightTypesChange) {
            this.props.onInsightTypesChange();
        }
        // we trigger redraw if show past production toggle changes
        // SPECIAL CASE when null:
        // in case previous value was null, than we are just opening the gantt chart
        // and when we open we also read default or last value and store it in redux
        // in such case we do not trigger redraw.
        if (
            prev_props.show_past_productions !== null &&
            prev_props.show_past_productions !== this.props.show_past_productions &&
            this.props.onShowPastProductionsChange
        ) {
            this.props.onShowPastProductionsChange();
        }
    }

    render() {
        return null;
    }
}

const mapState = (state: ReduxState) => ({
    insight_types: state.standalone_gantt.insight_types,
    show_past_productions: state.gantt_chart_properties.show_past_productions,
});

const mapDispatch = (dispatch: Dispatch<ActionTypes>) => ({ reduxDispatch: dispatch });

type ReduxProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

export default connect<ReturnType<typeof mapState>, ReturnType<typeof mapDispatch>, OwnProps, ReduxState>(
    mapState,
    mapDispatch
)(GanttChartStandaloneCallbacks);
